import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

const EVENTS = [
    { type: 'audit_pass', text: 'Alex P. passed Closing Audit', time: 'Just now', value: '98%', color: 'green' },
    { type: 'deal_close', text: 'New Deal: TechCorp Inc.', time: '12s ago', value: '$12,500', color: 'green' },
    { type: 'audit_fail', text: 'Sara M. failed Compliance Check', time: '45s ago', value: 'Critical', color: 'red' },
    { type: 'deal_reject', text: 'Deal Rejected: Omega LLC', time: '1m ago', value: 'Missing Recording', color: 'red' },
    { type: 'streak', text: 'Team Alpha: 50 Audit Streak!', time: '2m ago', value: '', color: 'blue' },
];

export default function Ticker() {
    const [events, setEvents] = useState(EVENTS);

    // Simulate "Live" feed
    useEffect(() => {
        const interval = setInterval(() => {
            setEvents(prev => {
                const last = prev[prev.length - 1];
                const others = prev.slice(0, prev.length - 1);
                return [last, ...others];
            });
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="live-ops-ticker">
            <div className="ticker-label">
                LIVE OPS
            </div>

            <div style={{ display: 'flex', gap: '48px', paddingLeft: '24px', whiteSpace: 'nowrap', animation: 'marquee 20s linear infinite' }}>
                {/* Repeating items for marquee effect */}
                {[...events, ...events].map((evt, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {evt.type.includes('pass') || evt.type.includes('close') ? <ObliqueIcon name="check_circle" size={14} style={{ color: "var(--success)" }} /> :
                            evt.type.includes('streak') ? <ObliqueIcon name="trending_up" size={14} style={{ color: "var(--accent)" }} /> : <ObliqueIcon name="warning" size={14} style={{ color: "var(--danger)" }} />}

                        <span style={{ fontSize: '13px', color: 'var(--text-primary)', fontWeight: '500' }}>{evt.text}</span>
                        <span style={{
                            fontSize: '11px',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            background: evt.color === 'green' ? 'var(--success-subtle)' : evt.color === 'red' ? 'var(--danger-subtle)' : 'var(--accent-subtle)',
                            color: evt.color === 'green' ? 'var(--success)' : evt.color === 'red' ? 'var(--danger)' : 'var(--accent)',
                            fontWeight: '500'
                        }}>
                            {evt.value}
                        </span>
                    </div>
                ))}
            </div>

            <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
        </div>
    );
}
